export const shadows = {
  none: 'none',
  sm: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24)',
  md: '0px 2px 8px rgba(0, 0, 0, 0.20), 0px 4px 24px rgba(0, 0, 0, 0.20)',
  lg: '0px 4px 12px rgba(0, 0, 0, 0.15), 0px 8px 32px rgba(0, 0, 0, 0.15)',
  xl: '0px 8px 24px rgba(0, 0, 0, 0.12), 0px 16px 48px rgba(0, 0, 0, 0.12)',
  
  // Specific use cases
  card: '0px 2px 8px rgba(0, 0, 0, 0.20), 0px 4px 24px rgba(0, 0, 0, 0.20)',
  drawer: '0px 2px 8px rgba(0, 0, 0, 0.20), 0px 4px 24px rgba(0, 0, 0, 0.20)',
  modal: '0px 8px 24px rgba(0, 0, 0, 0.12), 0px 16px 48px rgba(0, 0, 0, 0.12)',
  dropdown: '0px 4px 12px rgba(0, 0, 0, 0.15), 0px 8px 32px rgba(0, 0, 0, 0.15)',
} as const;